import { render } from "./Gallery.vue?vue&type=template&id=691ec4c6&scoped=true&lang=pug&bindings={\"images\":\"props\",\"openLightbox\":\"setup\"}"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=691ec4c6&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-691ec4c6"

export default script